import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent } from '../icon/icon.component';
import { SelectedItemPipe } from './selected-item.pipe';

@Component({
  selector: 'web-design-system-select',
  imports: [IconComponent, NgbDropdownModule, SelectedItemPipe, TranslocoPipe],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
})
export class SelectComponent {
  @Input() public items: Item[];
  @Input() public placeholder: string;
  @Input() public hasError: boolean;
  @Input() public error: string;

  @Output() public selectItem = new EventEmitter<Item>();

  public select(item: Item) {
    this.items = this.items.map((i) => ({ ...i, selected: i.value === item.value }));
    this.selectItem.emit(item);
  }
}

export interface Item {
  label: string;
  value: string | number;
  selected?: boolean;
}
